import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ViewTransitionStateService {
    readonly #isReady = new Subject<void>();
    readonly #isFinished = new Subject<void>();
    readonly #isScheduled = new BehaviorSubject<boolean>(false);
    readonly #isProductSwitch = new BehaviorSubject<boolean>(false);

    get whenReady(): Observable<void> {
        return this.#isReady.asObservable();
    }

    get whenFinished(): Observable<void> {
        return this.#isFinished.asObservable();
    }

    get isScheduled(): boolean {
        return this.#isScheduled.value;
    }

    get isProductSwitch(): boolean {
        return this.#isProductSwitch.value;
    }

    setReady(): void {
        this.#isReady.next();
    }

    setFinished(): void {
        this.#isFinished.next();
    }

    setScheduled(value: boolean): void {
        this.#isScheduled.next(value);
    }

    setIsProductSwitch(value: boolean): void {
        this.#isProductSwitch.next(value);
    }
}
